import React from 'react';
import { Link } from 'react-router-dom';
export function ProblemSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-266">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-267">
        <div className="max-w-3xl mx-auto text-center" data-id="element-268">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111111] mb-6" data-id="element-269">
            The digital safety net your family actually needs
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-6" data-id="element-270">
            Caveo was purpose-built to make digital security approachable and
            achievable. By replacing fragmented, technical tools with a unified,
            AI-guided experience, we are bringing cybersecurity to the masses
          </p>
          
          <p className="text-base text-gray-500 mb-8" data-id="element-271">
            No downloads, no jargon, and no prior tech knowledge required.
          </p>
          <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-272">
            Start Now
          </Link>
        </div>
      </div>
    </section>;
}